<template>
  <div>
    <h1 class="mb-1">Progressão de nível de comissionamento</h1>
    <div v-if="loading" class="d-flex justify-content-center">
      <b-spinner variant="primary" />
    </div>
    <template v-else-if="details">
      <b-table
        hover
        :items="details"
        borderless
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="Não foram encontrados consultores"
        :busy="loading"
        @row-clicked="goToConsultantDetails"
      >
        <!-- Column: consultant -->
        <template #cell(consultant_role)="data">
          <div class="text-wrap">
            <span class="align-text-top text-capitalize">{{
              data.item.consultant_role
            }}</span>
          </div>
        </template>
        <!-- Column: role -->
        <template #cell(date)="data">
          <div class="text-wrap">
            <span class="align-text-top text-capitalize">{{
              data.item.date | onlyDate
            }}</span>
          </div>
        </template>
      </b-table>
    </template>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BAvatar,
  BSpinner,
  BButton,
  BPopover,
  BCardText,
  BTable,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/modules/consultant/store/types";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
export default {
  components: {
    BRow,
    BCol,
    BAvatar,
    BSpinner,
    BButton,
    BPopover,
    BCardText,
    BTable,
  },
  setup() {
    return { toast: useToast() };
  },
  data() {
    return {
      loading: false,
      tableColumns: [
        { key: "consultant_role", label: "Nível" },
        { key: "date", label: "Data de aprovação" }
      ],
      details: null,
    };
  },
  mounted() {
    this.loading = true;
    this.getConsultantRoleHistory(this.$route.params.id)
      .then((response) => {
        this.details = response.data;
      })
      .catch(() => {
        this.toast({
          component: ToastificationContent,
          props: {
            title: "Oops!",
            text: "Ocorreu um erro ao obter o histórico de níveis do PN. Entre em contato com o setor de TI.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        this.$router.push({ name: "consultants-list" });
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    ...mapActions({
      getConsultantRoleHistory: types.GET_CONSULTANT_ROLES_HISTORY,
    }),
    goToConsultantDetails(consultant, index) {
      this.$router.push({
        name: "consultant-details-summary",
        params: { id: consultant.consultant_id },
      });
    },
  },
};
</script>
